export enum RelatorioReceitaEvents {
  Filtrar = "Relatorio_Receita_Filtrar",
  ExportarPDF = "Relatorio_Receita_Exportar_PDF",
  ExportarExcel = "Relatorio_Receita_Exportar_Excel",
}

export enum RelatorioReceitaComposicaoEvents {
  Filtrar = "Relatorio_Receita_Composicao_Filtrar",
  ExportarPDF = "Relatorio_Receita_Composicao_Exportar_PDF",
  ExportarExcel = "Relatorio_Receita_Composicao_Exportar_Excel",
}

export enum RelatorioDespesaComposicaoEvents {
  Filtrar = "Relatorio_Despesa_Composicao_Filtrar",
  ExportarPDF = "Relatorio_Despesa_Composicao_Exportar_PDF",
  ExportarExcel = "Relatorio_Despesa_Composicao_Exportar_Excel",
}

export enum RelatorioReceitaComposicaoHorizontalEvents {
  Filtrar = "Relatorio_Receita_Composicao_Horizontal_Filtrar",
  ExportarPDF = "Relatorio_Receita_Composicao_Horizontal_Exportar_PDF",
  ExportarExcel = "Relatorio_Receita_Composicao_Horizontal_Exportar_Excel",
}

export enum RelatorioCertidaoNegativaDebitosEvents {
  Emitir = "Relatorio_Certidao_Negativa_Debitos_Emitir",
}

export enum RelatorioPortariaEvents {
  ExportarPDF = "Relatorio_Portaria_Exportar_PDF",
  ExportarExcel = "Relatorio_Portaria_Exportar_Excel",
}

export enum RelatorioInadimplentesEvents {
  ExportarPDF = "Relatorio_Inadimplentes_Exportar_PDF",
  ExportarExcel = "Relatorio_Inadimplentes_Exportar_Excel",
}
